export const getPutOptions = (jsonString) => {
    return {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: jsonString
      }
}

export const dynamicSort = (data, sortBy, isAsc) => {
  return [...data].sort( (a,b) => {
    return ((a[sortBy]).toLowerCase() < (b[sortBy]).toLowerCase() ? -1 : 1) * (isAsc ? 1 : -1)
  });
}

export const getFeet = inches => Math.floor(inches / 12);
export const getInches = (inches) => (inches - (Math.floor(inches / 12) * 12));


export const getCurrentDate = new Date().toISOString().slice(0,10);

export const customRound = (num, decimalPlaces = 0) => {
  const factor = Math.pow(10, decimalPlaces)
  return Math.round(num * factor) / factor
}

export const getStatusColor = (compliance)=>{
  const {completed, scheduled} = compliance;
  let num = Math.floor((completed/scheduled) * 100)
  if(num > 90) {
    return '#2ECC71';
  }
  if(num <= 90 && num > 75) {
    return '#FFE100'; //Yellow
  }
  if(num <= 75) {
    return '#CB1415'; //red
  }
}

export const isEmpty  = (obj) => {
  return Object.keys(obj).length === 0;
}

export const completePercent = (obj) => {
  let compPer = 0;
  compPer = obj.completed > 0 ?  Math.round((obj.completed/obj.scheduled) * 100) : 0;
  return compPer;
}

export const formatPhoneNumber = (number) => {
  let formattedNumber;
  const length  = number ? number.length : 0;
  // Filter non numbers
  const regex = () => number.replace(/[^0-9\.]+/g, "");
  // Set area code with parenthesis around it
  const areaCode = () => `(${regex().slice(0, 3)})`;
  
  // Set formatting for first six digits
  const firstSix = () => `${areaCode()} ${regex().slice(3, 6)}`;
  
  // Dynamic trail as user types
  const trailer = (start) => `${regex().slice(start, regex().length)}`;
    if (length < 3) {
       // First 3 digits
       formattedNumber = regex();
    } else if (length === 4) {
       // After area code
       formattedNumber = `${areaCode()} ${trailer(3)}`;
    } else if (length === 5) {
       // When deleting digits inside parenthesis
       formattedNumber = `${areaCode().replace(")", "")}`;
    } else if (length > 5 && length < 9) {
       // Before dash
       formattedNumber = `${areaCode()} ${trailer(3)}`;
    } else if (length >= 10) {
       // After dash
       formattedNumber = `${firstSix()}-${trailer(6)}`;
    }
  
    return formattedNumber;
};
